module.exports = __webpack_public_path__ + "img/nodata.67990665.png";